import React, { useEffect, useState } from "react";
import { getMapLoader } from "./utils";

interface IMapInitializer {
  children?: React.ReactNode;
}

export const MapInitializer: React.FC<IMapInitializer> = ({ children }) => {
  const [isInited, setIsInited] = useState(false);

  useEffect(() => {
    const loader = getMapLoader();

    loader.load().then(async () => {
      setIsInited(true);
    });
  }, []);

  return <>{isInited ? children : null}</>;
};
